export default __webpack_public_path__ + "3e1f6742f484bbc498fe8eeb423680d4.png";